export default "__VITE_ASSET__CVOewagr__"